export const range = (start: number, end: number, length = end - start) =>
  Array.from({ length }, (_, i) => start + i);

declare global {
  interface ObjectConstructor {
    // eslint-disable-next-line @typescript-eslint/ban-types
    fromEntries(xs: [string | number | symbol, any][]): object;
  }
}

const fromEntries = (xs: [string | number | symbol, any][]) =>
  Object.fromEntries
    ? Object.fromEntries(xs)
    : xs.reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

export const objectMap = (obj: any, fn: any) =>
  fromEntries(Object.entries(obj).map(([k, v], i) => [k, fn(v, k, i)]));

export const getGetParam = (needle: string): string => {
  const param: any = document.location.search
    .substr(1)
    .split('&')
    .filter((p) => p)
    .map((p: string) => {
      const { 0: key, 1: value } = p.split('=');
      return { key, value };
    })
    .filter((p) => p.key === needle)
    .pop();

  if (param) {
    return param.value;
  }
  return '';
};

export const toggle = (arr: any[], item: any) =>
  arr.includes(item) ? arr.filter((i) => i !== item) : [...arr, item];

export const shuffle = (parent: Element) => {
  const list = Array.from(parent.children);

  list.sort(() => {
    return -1 + Math.random() * 3; // -1, 0, or 1
  });

  while (parent.children.length > 0) {
    parent.removeChild(parent.children[0]);
  }
  list.forEach((el) => {
    parent.appendChild(el);
  });
};

export const getDataUri = (url: string): Promise<string> => {
  return new Promise((resolve) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';

    image.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = image.naturalWidth;
      canvas.height = image.naturalHeight;

      const context = canvas.getContext('2d');

      if (context) {
        context.drawImage(image, 0, 0);

        resolve(canvas.toDataURL('image/png'));
      }
    };

    image.src = url;
  });
};

export const chunk = (arr: any[], chunkSize: number) => {
  const R = [];
  for (let i = 0, len = arr.length; i < len; i += chunkSize)
    R.push(arr.slice(i, i + chunkSize));
  return R;
};

export const lockScrolling = (visible: boolean): void => {
  if (visible) {
    document.documentElement.style.setProperty('overflow-y', 'hidden');
  } else {
    document.documentElement.style.setProperty('overflow-y', '');
  }
};

export const mqMedium = window.matchMedia('(min-width: 768px)');
export const mqLarge = window.matchMedia('(min-width: 1024px)');
export const isTouch = window.matchMedia('(pointer:coarse)');
export const canHover = window.matchMedia('(hover: hover)');

export const lang = document.documentElement.lang === 'de' ? 'de' : 'en';

export const dispatchWindowEvent = (name: string) => {
  let event;

  if (typeof Event === 'function') {
    event = new Event(name);
  } else {
    event = document.createEvent('Event');
    event.initEvent(name, false, false);
  }

  window.dispatchEvent(event);
};
